import { injectReCaptchaToken } from '@common/Services/recaptcha-service';

const termsOfUseAgreeButton = () => <JQuery<HTMLElement>>$('#btnTosAgree');
const termsOfUseSection = () => <JQuery<HTMLElement>>$('#js-tos-section');
const loginSection = () => <JQuery<HTMLElement>>$('#js-login-section');
const form = () => <JQuery<HTMLFormElement>>$('form');

export function init(): void {
	termsOfUseAgreeButton().on('click', () => hideTermsOfUse());
	form().on('submit', (ev) => injectReCaptchaToken(ev, 'Login'));

	termsOfUseAgreeButton().prop('disabled', false);
}

export function hideTermsOfUse(): void {
	termsOfUseSection().addClass('d-none');
	termsOfUseSection().remove();

	loginSection().removeClass('d-none');
}

// Using the window load event instead of $(init) to wait until all scripts are loaded.  $(init) only waits until the DOM is loaded.
$(window).on('load', init);